import * as React from "react";

;
export const PopoverClose = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} fill="none" {...props}><rect width={14.5} height={14.5} x={0.75} y={1.25} stroke="#CFCDD3" strokeWidth={1.5} rx={3.25} /><path fill="#585265" d="m12 8.5-6.75 3.897V4.603L12 8.5Z" /></svg>;